import images from "../../../assets";
import PrimaryButton from "../../button/primarybutton";

export default function ActiveNowUser() {
  return (
    <div className="w-full p-4 bg-white rounded-2xl justify-between items-end gap-[47px] inline-flex">
      <div className="w-56 h-[99px] flex-col justify-between items-center inline-flex">
        <div className="self-stretch justify-between items-start inline-flex">
          <div className="grow shrink basis-0 flex-col justify-start items-start gap-[13px] inline-flex">
            <h4 className="opacity-70 text-[#222222]/60 text-base font-normal  leading-normal">
              Active Now Users
            </h4>
            <div className="self-stretch justify-start items-center gap-[13px] inline-flex">
              <p className="text-[#222222] text-3xl font-semibold  leading-9">
                294
              </p>
              <div className="justify-center items-center gap-2 flex">
                <div className="w-5 h-5 relative">
                  <img src={images.historyIcon} />
                </div>
                <div>
                  <span className="text-[#f31260] text-xs font-normal  leading-[18px]">
                    1.5%
                  </span>{" "}
                  <span className="text-[#222222]/60 text-xs font-normal  leading-[18px]">
                    less from yesterday
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="self-stretch justify-between items-center gap-2 inline-flex">
          <p className="text-[#222222]/60 text-base font-normal  leading-normal">
            Last 7 days
          </p>
          <div className="justify-center items-center gap-2 flex">
            <div className="w-5 h-5 relative">
              <img src={images.upArrow} />
            </div>
            <p className="text-[#17c964] text-base font-normal  leading-normal">
              634
            </p>
          </div>
          <div className="justify-center items-center gap-2 flex">
            <div className="w-5 h-5 relative">
              <img src={images.downArrow} />
            </div>
            <p className="text-[#f31260] text-base font-normal  leading-normal">
              120
            </p>
          </div>
        </div>
      </div>
      <div className="justify-center items-center flex">
        <PrimaryButton
          style={{
            height: "32px",
            width: "188px",
            fontSize: "16px",
            fontWeight: 500,
          }}
          text={"Send Message"}
          iconalign="left"
          icon={images.messageIcon}
        />
      </div>
    </div>
  );
}
